import axios from "axios";
import { notifySuccess, notifyError } from './Notification';

// const url = process.env.REACT_APP_BASE_URL;
const { REACT_APP_API_ENDPOINT } = process.env;

const axiosInstance = axios.create({
  // baseURL: 'http://127.0.0.1:8000/api', 
  baseURL: `${REACT_APP_API_ENDPOINT}/api/admission/`,
  timeout: 120000,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("userToken")}`,
  },
});


const apiKey = process.env.REACT_APP_API_KEY;

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("userToken");
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (apiKey) {
      config.headers['X-API-KEY'] = apiKey;
    }
    return config;
  },
  (error) => {
    console.error('Error in request:', error);
    return Promise.reject(error);
  }
);





export const fetchData = async (endpoint, searchText) => {
  try {
    const response = await axiosInstance.get(endpoint, {
      params: {
        searchText: searchText,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    notifyError('Error fetching data');
    return { error: error.response?.status || 500 };
  }
};

export const signup = async (data) => {
  try {
    const response = await axiosInstance.post('/signup', data);
    notifySuccess("Signup successful!");
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.email ? error.response.data.email[0] : "Signup failed!";
    notifyError(errorMessage);
    console.error("Error during signup:", error);
    throw error;
  }
};


export const uploadDocument = async (studentId, documentType, file) => {
  const formData = new FormData();
  formData.append('file', file); // Key should match in the backend

  try {
    const response = await axiosInstance.post(`/document_completion/${studentId}/upload_previous_school_record/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: {
        document_type: documentType,
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error uploading document:", error);
    throw error;
  }
};


export const checkDocumentStatus = async (studentId) => {
  try {
    const response = await axiosInstance.get(`/document_completion/${studentId}/check_document_status/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching document status:", error);
    throw error;
  }
};

export const loadAdmissionFormDetail = async (studentId) => {
  try {
    const response = await axiosInstance.get(`/admission-form/status/${studentId}/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching document status:", error);
    throw error;
  }
};


export const getParentData = async (userId) => {
  try {
    const response = await axiosInstance.get(`/parents/${userId}`);
    notifySuccess("Parent Data Loaded");
    return response.data; 
  } catch (error) {
    notifyError("Parent Data Loading failed");
    console.error('Failed to fetch parent data:', error);
    throw error; 
  }
};


export const fetchProgress = async (studentId) => {
  try {
    const response = await axiosInstance.get(`/student_progress/${studentId}/`);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch progress:', error);
    throw error;
  }
};


export const login = async (loginData) => {
  try {
    const response = await axiosInstance.post('/login', loginData);
    const { token, user_id } = response.data;
    localStorage.setItem("userToken", token.access); // Store access token
    localStorage.setItem("userID", user_id); // Store user ID
    console.log(user_id)
    notifySuccess("Login successful!");
    return { access: token.access, user_id }; 
  } catch (error) {
    notifyError("Login failed!");
    throw error;
  }
};

export const submitCodeOfConduct = async (formData) => {
  try {
    const response = await axiosInstance.post(`/code_of_conduct/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    notifySuccess("Form submitted successfully!");
    return response.data;
  } catch (error) {
    notifyError("Failed to submit the form.");
    console.error('Failed to submit the form.', error);
    throw error;
  }
};

export const submitMedicalForm = async (formData) => {
  try {
    const response = await axiosInstance.post(`/medical_form/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    notifySuccess("Medical form submitted successfully!");
    return response.data;
  } catch (error) {
    notifyError("Failed to submit the medical form.");
    console.error('Failed to submit the medical form.', error);
    throw error;
  }
};


export const submitMYPSubjectSelectionForm = async (formData) => {
  try {
    const response = await axiosInstance.post(`/myp_subject_selection_form/`, formData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    notifySuccess("MYP subject selection form submitted successfully!");
    return response.data;
  } catch (error) {
    notifyError("Failed to submit the MYP subject selection form.");
    console.error('Failed to submit the MYP subject selection form.', error);
    throw error;
  }
};



export const submitDPSubjectSelectionForm = async (formData) => {
  try {
    const response = await axiosInstance.post(`/dp_subject_selection_form/`, formData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    notifySuccess("DP subject selection form submitted successfully!");
    return response.data;
  } catch (error) {
    notifyError("Failed to submit the DP subject selection form.");
    console.error('Failed to submit the DP subject selection form.', error);
    throw error;
  }
};



export const submitEssayShortResponseForm = async (formData) => {
  try {
    const response = await axiosInstance.post(`/essay_short_response_form/`, formData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    notifySuccess("Essay short response form submitted successfully!");
    return response.data;
  } catch (error) {
    notifyError("Failed to submit the essay short response form.");
    console.error('Failed to submit the essay short response form.', error);
    throw error;
  }
};

export const submitLanguageSurveyForm = async (formData) => {
  try {
    const response = await axiosInstance.post(`/language_survey_form/`, formData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    notifySuccess("Language survey form submitted successfully!");
    return response.data;
  } catch (error) {
    notifyError("Failed to submit the language survey form.");
    console.error('Failed to submit the language survey form.', error);
    throw error;
  }
};


export const getStudentByParent = async (userId) => {
  try {
    const response = await axiosInstance.get(`/students-by-parent/${userId}`);
    notifySuccess("Student Data Loaded");
    return response.data; 
  } catch (error) {
    notifyError("Failed to load student data");
    console.error('Failed to fetch student data:', error);
    throw error; 
  }
};

export const submitAdmissionForm = async (formData) => {
  try {
    const form = new FormData();

    // Append non-file data
    Object.keys(formData).forEach(key => {
      if (key === 'parentInfo' || key === 'addressInfo' || key === 'previousSchools') {
        form.append(key, JSON.stringify(formData[key]));
      } else if (key !== 'childImage' && key !== 'signatureImage') {
        form.append(key, formData[key]);
      }
    });

    // Append file data
    if (formData.childImageFile) {
      form.append('childImage', formData.childImageFile);
    }
    if (formData.signatureImageFile ) {
      form.append('signatureImage', formData.signatureImageFile);
    }

    const response = await axiosInstance.post('/admission/', form, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    notifySuccess("Form submitted successfully!");
    return response.data;
  } catch (error) {
    notifyError("Failed to submit the form.");
    console.error('Submission error:', error);
    throw error;
  }
};

export const checkEmail = async (email) => {
  try {
    const response = await axiosInstance.post('/check_email/', { email });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const confirmPhoneNumber = async (parentId, phoneNumber) => {
  try {
    const response = await axiosInstance.post('/confirm_phone_number/', { parent_id: parentId, phone_number: phoneNumber });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const resetPassword = async (parentId, newPassword, confirmPassword) => {
  try {
    const response = await axiosInstance.post('/reset_password/', {
      parent_id: parentId,
      new_password: newPassword,
      confirm_password: confirmPassword
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};


export default axiosInstance;
